/* eslint-disable */
import { produce } from "immer";
import create from "zustand";

export type SellConfirmData = {
  // total: number,
  // weight: number,
  // gst: number,
  // cess: number,
  // discountPercent: number,
  // discountAmount: number,
  // amountToPay: number,
  // sellLotId: string,
  // error: boolean,
  // message: string,
  // msgKey: string

  bankRefNo: null;
  error: string;
  goldValue: number;
  gst: number;
  id: number;
  message: string;
  msgKey: string;
  saleGoldRate: number;
  transactionId: string;
  weight: number;
};

export const SellConfirmInitialData = {
    bankRefNo: null,
    error: '',
    goldValue: 0,
    gst:0,
    id:0,
    message: "",
    msgKey: "",
    saleGoldRate:0,
    transactionId: "",
    weight:0,
};
type SellConfirm = {
  confirmData: SellConfirmData;
};

const initialState: SellConfirm = {
  confirmData: SellConfirmInitialData,
};

export type SellConfirmStore = {
  updateSellConfirmResponse: (VerifyData: SellConfirm["confirmData"]) => void;
  resetSellConfirmData: () => void;
};

export const useSellConfirmStore = create<SellConfirm & SellConfirmStore>(
  (set) => ({
    ...initialState,
    updateSellConfirmResponse: (confirmData) => {
      set(
        produce((state: SellConfirm) => {
          state.confirmData = confirmData;
        })
      );
    },
    resetSellConfirmData: () => set(initialState),
  })
);
